import { useQuery } from '@tanstack/react-query';
import { useInjection } from 'inversify-react';
import { goodsReceivingQueryKeys } from '../../pages/goods-receiving/query-keys';
import { LotStorageService } from '../../services/lot-storage/lot-storage.service';
import type { ILotStorageService } from '../../services/lot-storage/lot-storage.types';

export function useLotStorageSuggestions(draftId: string | null) {
  const service = useInjection<ILotStorageService>(LotStorageService);

  const { data, isLoading } = useQuery({
    queryKey: goodsReceivingQueryKeys.storageSuggestions(draftId ?? ''),
    queryFn: () => service.getSuggestions(draftId as string),
    enabled: !!draftId,
  });

  return { data, isLoading };
}
